import React, {useContext, useEffect, useMemo, useState} from 'react'
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import useTranslate from "../../../modules/local/useTranslate";
import {LoginContext} from "../../../components/LoginContext";
import {Switch} from "antd";
import {godwords_getSuggestedWords_Api, godwordsSchema} from "../../../apis/godwords";
import _ from "lodash"
import CRUD from "../../Shared/enums/CRUD";
import {NullAsDefault, renderIfElse} from "../../Shared";
import {getGodWordDisplayConfigKey, setGodWordDisplayConfigKey} from "../../../helpers/localStorage";
import ResponsiveTextLabel from "../../../components/ResponsiveTextLabel/ResponsiveTextLabel";
import {MdOutlineToggleOff, MdToggleOn} from "react-icons/md";
import {Link} from "react-router-dom";
import {useHistory} from "../../../modules/navigation/useRouter";
import {getRouteSearchParams, useRouteSearchParam} from "../../../envs/_current/history";
import {useGodWords} from "./functions/useGodWords";
import {SelectEntityItem} from "../../../components/SelectEntityItem";
import {getId} from "../../../apis/model/base";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {GodWordsDialog} from "./containers/WordOfGodDialog";
import Modal from "../../../components/Modal/Modal";
import {DelayRender} from "../../Discovery/DelayRender";
import {ViewMeditation} from "../Codi/CalendarLiturgicalTextForm";
import {LocalContext} from "../../../modules/local/LocalContext";
import {addElementToStackArray} from "../../../helpers/addElementToStackArray";
import {FaBackward, FaForward} from "react-icons/fa6";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import TooltipApp from "../../../components/TooltipApp";
import {getLinkToDetailRow} from "../Codi/codiHelpers";
import LoadingBlock from "../../LoadingBlock";
import dayjs from "dayjs";
import {PiHeart, PiHeartFill} from "react-icons/pi";
import {useRequiredLogin} from "../../Server/useRequiredLogin";

const WogComponent = ({children, defaultId, today = 0, ...props}) => {

    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const history = useHistory()
    const login = useContext(LoginContext)
    const displayConfig = getGodWordDisplayConfigKey();
    const [isLatestBookmark, setLatestBookmark] = useState(Number(displayConfig) === 1)
    const [action, setAction] = useState({type: undefined, value: undefined})
    const {timezone_offset_in_hours} = useContext(LocalContext)
    const [list, setList] = useState([])
    const [selectedItem, setSelectedItem] = useState()
    const handleRequiredLogin = useRequiredLogin()

    const onCancel = () => {
        const params = getRouteSearchParams()
        params.delete('popup')
        history.replace({
            search: params.toString(),
        })
        setAction({})
    }

    const onBack = () => {
        setSelectedItem(prevSelectedItem => {
            return _.cloneDeep(_.first(list));
        });
        let _list = _.cloneDeep(list);
        _list.shift();
        setList(prevList => {
            return _list;
        });

    };

    const popup = useRouteSearchParam('popup')

    const {response, isLoading = true, handleAsyncAction: fetchRandomGodWords} = useAsyncAction({
        apiInfo: godwords_getSuggestedWords_Api,
        onSuccess: (result, data) => {
            const selectedItem = (isLatestBookmark && !!!defaultId) ? item : _.get(data, 'response.data.data.0')
            setSelectedItem(selectedItem)
        },
    })

    useEffect(() => {
        if (!!!action.type && popup === 'divine-word') {
            setAction({type: CRUD.READ, value: {}});
        }
        let inputParam = {limit: 1, timezone_offset_in_hours}
        if (defaultId) inputParam.id = defaultId
        if (today) inputParam.today = 1;
        fetchRandomGodWords(
            {...inputParam},
            {}
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const item = _.get(response, 'data.item');
    const data = _.get(response, 'data.data', []);

    useEffect(() => {
        if (!_.isEmpty(response) && _.isEmpty(item) && isLatestBookmark) {
            setLatestBookmark(false);
            // setGodWordDisplayConfigKey("0")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLatestBookmark, item])

    useEffect(() => {
        const selectedItem = (isLatestBookmark && !!!defaultId) ? item : _.get(data, '0')
        setSelectedItem(selectedItem)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLatestBookmark, defaultId, item, data])

    const codi_page = _.get(selectedItem, 'codi_document_row') ?? {}

    const modal = useMemo(() => {
        let Content = NullAsDefault
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {
                    default_id: action.value?.id
                }
                modal_params = {
                    width: 640,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('divine word')}
                        </div>
                    ),
                }
                Content = GodWordsDialog
                break
            case "MEDITATION_VIEWER":
                params = {
                    // item: action.value
                }
                modal_params = {
                    width: 640,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('meditation')}
                        </div>
                    ),
                }
                Content = ViewMeditation
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Content
                        {...{
                            onCancel,
                            item: action.value,
                        }}
                        {...params}
                    />
                </DelayRender>
            </Modal>
        )
    }, [action])

    const {
        onVote, onDevote
    } = useGodWords({
        notifyListeners: {
            onVotedSuccess: (result) => {
                // onRefresh()
            },
            onDevotedSuccess: (result) => {
                // onRefresh()
            },
        },
    })

    const _selectedItem = !!selectedItem
        ? selectedItem
        : ((isLatestBookmark && !!!defaultId) ? item : _.get(data, '0'))

    const minHeight = isSm ? 140 : 179

    if (isLoading) {
        return <LoadingBlock style={{height: 240}}/>;
    }

    return (
        <React.Fragment>
            <SelectEntityItem
                item={getId(_selectedItem)}
                schema={godwordsSchema}>
                {(sItem) => {
                    const selItem = !!sItem ? sItem : _selectedItem;

                    return selItem ? (
                        <div className="flex flex-col gap-3">
                            <div className="flex items-center gap-2">
                                <div className="flex flex-col flex-1">
                                    <span
                                        onClick={() => {
                                            setAction({type: CRUD.READ, value: selItem});
                                        }}
                                        className="font-bold text-white tracking-wide cursor-pointer">
                                        {t('god word today')}
                                    </span>
                                    <span className="text-xs text-white-70 italic capitalize tracking-wide">
                                        {dayjs().format('dddd, DD MMMM, YYYY')}
                                    </span>
                                    <div className="my-1 w-20 h-1 rounded-full bg-gray-200"/>
                                </div>
                                {item && (
                                    <TooltipApp
                                        placement="left"
                                        color="white"
                                        title={
                                            <div className="flex flex-col">
                                            <span className="flex items-center gap-2">
                                                <MdToggleOn className="text-color-100"/>
                                                <span
                                                    className="text-2xs text-color-100 italic">{t('bookmarked items')}</span>
                                            </span>
                                                <span className="flex items-center gap-2">
                                                <MdOutlineToggleOff className="text-color-100"/>
                                                <span className="text-2xs text-color-100 italic">{t('random')}</span>
                                            </span>
                                            </div>
                                        }>
                                        <Switch
                                            size="small"
                                            checked={isLatestBookmark}
                                            onChange={(checked) => {
                                                setGodWordDisplayConfigKey(checked ? 1 : 0)
                                                setLatestBookmark(checked)
                                            }}
                                        />
                                    </TooltipApp>
                                )}
                            </div>
                            <div style={{minHeight: minHeight}} className="flex flex-center z-3 relative">
                                {selItem && selItem?.content ? (
                                    <div style={{minHeight: minHeight}}
                                         className="w-full h-full flex flex-col flex-center gap-4">
                                        <div className="p-4 flex flex-col flex-center background shadow-md rounded-3xl">
                                            {selItem?.content ? (
                                                <Link to={getLinkToDetail(selItem)}
                                                      className="font-medium text-green-600 no-underline">
                                                    <ResponsiveTextLabel text={selItem?.content}/>
                                                </Link>
                                            ) : (
                                                <LoadingBlock className="h-48"/>
                                            )}
                                            <div className="mt-3 flex flex-center gap-4">
                                                <div style={{height: 1}} className="w-5 bg-primary-400"/>
                                                <Link
                                                    to={getLinkToDetailRow(codi_page) || "#"}
                                                    target="_blank"
                                                    className="font-bold text-xs text-primary no-underline">
                                                    {selItem?.source_text}
                                                </Link>
                                                <div style={{height: 1}} className="w-5 bg-primary-400"/>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <LoadingBlock/>
                                )}
                            </div>
                            <div
                                className="mt-2 px-4 py-1 w-fit mx-auto flex items-center gap-3 bg-white-30 border border-white-50 shadow-md rounded-full bottom-action">
                                <div className="flex items-center gap-6 flex-1 justify-center" style={{minWidth: 80}}>
                                    <TooltipApp title={t('prev doc')} classNames={{root: "font-medium text-xs italic"}} className="flex flex-center">
                                        <FaBackward
                                            onClick={() => {
                                                if (list.length) {
                                                    onBack()
                                                }
                                            }}
                                            size={22}
                                            className={list.length > 0 ? 'text-blue-600 opacity-70 hover:opacity-85 cursor-pointer' : 'text-white opacity-30'}
                                        />
                                    </TooltipApp>
                                    <div
                                        className="p-2 w-10 h-10 flex flex-center bg-white-70 shadow-md rounded-full hover:scale-115">
                                        {renderIfElse(
                                            !!selItem?.vote_status,
                                            <PiHeartFill
                                                size={22}
                                                className="flex text-primary hover:text-primary-700 cursor-pointer"
                                                onClick={() => {
                                                    handleRequiredLogin(() => {
                                                        onDevote({owner_type: 'god_word', owner_id: selItem?.id})
                                                    })
                                                }}
                                            />,
                                            <TooltipApp title={t('bookmarked items')}
                                                        classNames={{root: "font-medium text-xs italic"}}>
                                                <PiHeart
                                                    size={22}
                                                    className="flex text-blue-500 hover:text-primary cursor-pointer"
                                                    onClick={() => {
                                                        handleRequiredLogin(() => {
                                                            onVote({owner_type: 'god_word', owner_id: selItem?.id})
                                                        })
                                                    }}
                                                />
                                            </TooltipApp>
                                        )}
                                    </div>
                                    <TooltipApp title={t('next doc')} classNames={{root: "font-medium text-xs italic"}} className="flex flex-center">
                                        <FaForward
                                            onClick={() => {
                                                const arr = addElementToStackArray(_.cloneDeep(list), _.cloneDeep(selItem), 100);
                                                setList(arr)
                                                fetchRandomGodWords(
                                                    {limit: 1, timezone_offset_in_hours, exclude_id: selItem?.id},
                                                    {}
                                                )
                                            }}
                                            size={22}
                                            className="opacity-60 hover:opacity-85 text-blue-600 cursor-pointer"
                                        />
                                    </TooltipApp>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <LoadingBlock className="h-48 min-h-48" style={{height: 240}}/>
                    )
                }}
            </SelectEntityItem>
            {modal}
        </React.Fragment>
    )
}

export default WogComponent
